import { http } from '../../../api/axios';
import { cartConfig } from '../../../config';

interface BulkImportResponse {
    alreadyInListProducts: string[];
    response: string;
    successful: boolean;
}
export const bulkImportIsbns = (isbns: string) => {
    return http.post<BulkImportResponse>(cartConfig().importBulkIsbn, { isbns }).then(response => response.data);
};
